// FUNCTION TO INSERT CURRENT DATE IN INPUTS [TYPE=DATE]
export function controlDate(type) {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hour = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const currentDateFull = `${year}-${month}-${day}T${hour}:${minutes}`;
    const currentDate = `${year}-${month}-${day}`;
    const minDay = String(date.getDate() + 1).padStart(2, "0");
    const minimumDate = `${year}-${month}-${minDay}`;
    const inputDate = document.querySelectorAll(type);
    const inputTime = document.querySelectorAll('input[type="time"]');
    inputDate.forEach((input) => {
      if (type === 'input[type="datetime-local"]') {
        input.value = currentDateFull;
        input.min = currentDateFull;
        input.addEventListener("blur", () => {
          if (input.value < currentDateFull) {
            input.value = currentDateFull;
          }
        });
      } else {
        input.value = minimumDate;
        input.min = minimumDate;
        input.addEventListener("blur", () => {
          const event = new Event("blur");
          inputTime.forEach((time) => time.dispatchEvent(event));
          if (input.value < currentDate) {
            input.value = currentDate;
          }
        });
      }
    });
    inputTime.forEach((time) => {
      time.addEventListener("blur", () => {
        const inputTimeError = document.querySelector("span.input-time-error");
        if (inputTimeError) {
          inputTimeError.remove();
        }
        let inputTimeErrorElement = "";
        let scheduleDay;
        inputDate.forEach((day) => {
          scheduleDay = day.value.slice(-2);
        });
        if (day === scheduleDay) {
          time.min = `${String(Number(hour) + 1).padStart(2, "0")}:${minutes}`;
          if (time.min.slice(0, 2) >= 18) {
            inputTimeErrorElement =
              inputTimeErrorElement ||
              createMarkupErrorInputTime(
                `Para hoje não há mais horários disponíveis.`
              );
          }
        }
        if (day !== scheduleDay && time.min !== "08:00") {
          time.min = "08:00";
        }
        if (!time.value || time.value < time.min || time.value > time.max) {
          time.value = "";
          inputTimeErrorElement =
            inputTimeErrorElement ||
            createMarkupErrorInputTime(
              `Escolher um horário das ${time.min} às ${time.max}.`
            );
        }
        inputTimeErrorElement
          ? time.insertAdjacentHTML("beforebegin", inputTimeErrorElement)
          : inputTimeError?.remove();
      });
    });
  }
  function createMarkupErrorInputTime(msg) {
    return `<span class="input-time-error ml-5">${msg}</span>`;
  }